export const FAMILY = 'FAMILY';
export const PLAY = 'PLAY';
export const GAMER = 'GAMER';
export const LIGHT = 'LIGHT';
